var _path, _path2, _path3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path4, _path5, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _path6, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlan(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 19.724 19.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.63,2.7h-4v.74h4.23a.35.35,0,0,1,.35.35V14.64a.35.35,0,0,1-.35.35H18.62v.74h4a1.32,1.32,0,0,0,1.31-1.32V4A1.32,1.32,0,0,0,22.63,2.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.37,15.73h4V15H2.15a.35.35,0,0,1-.35-.35V3.79a.35.35,0,0,1,.35-.35H6.38V2.7h-4A1.32,1.32,0,0,0,1.06,4V14.41A1.32,1.32,0,0,0,2.37,15.73Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.72,1.06H8.28a1.1,1.1,0,0,0-1.1,1.1v14a1.1,1.1,0,0,0,1.1,1.1h2.29v-.85H8.36A.45.45,0,0,1,7.91,16V2.36a.45.45,0,0,1,.45-.45h8.28a.45.45,0,0,1,.45.45V16a.45.45,0,0,1-.45.45H14.43v.85h2.29a1.1,1.1,0,0,0,1.1-1.1v-14A1.1,1.1,0,0,0,16.72,1.06Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.36,
    y: 4.23,
    width: 1.02,
    height: 0.68
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.78,
    y: 4.23,
    width: 0.68,
    height: 0.68
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.53,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(12.71 0.62) rotate(90)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 3.95,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(11.13 2.21) rotate(90)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 2.48,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(9.65 3.68) rotate(90)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.12,
    y: 8.54,
    width: 2.27,
    height: 0.57
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 5.02,
    y: 10.01,
    width: 1.36,
    height: 0.57
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.63,12.26H11.37a1.13,1.13,0,1,0,0,2.26h2.26a1.13,1.13,0,1,0,0-2.26Zm-.14,1.67h-2a.54.54,0,0,1,0-1.08h2a.54.54,0,0,1,0,1.08Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38,13.11H4.29a.54.54,0,0,1-.53-.54A.54.54,0,0,1,4.29,12h2l.1,0v-.61H4.15a1.14,1.14,0,0,0,0,2.27H6.38Z"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.62,
    y: 4.23,
    width: 1.02,
    height: 0.68,
    transform: "translate(38.25 9.14) rotate(-180)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 20.54,
    y: 4.23,
    width: 0.68,
    height: 0.68,
    transform: "translate(41.76 9.14) rotate(-180)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 18.45,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(25.62 -12.29) rotate(90)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.03,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(27.21 -13.87) rotate(90)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 21.5,
    y: 6.33,
    width: 1.02,
    height: 0.68,
    transform: "translate(28.68 -15.35) rotate(90)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 18.62,
    y: 8.54,
    width: 2.27,
    height: 0.57,
    transform: "translate(39.5 17.64) rotate(-180)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 18.62,
    y: 10.01,
    width: 1.36,
    height: 0.57,
    transform: "translate(38.59 20.58) rotate(-180)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.62,13.11h2.09a.54.54,0,0,0,.53-.54.54.54,0,0,0-.53-.54h-2l-.1,0v-.61h2.23a1.14,1.14,0,0,1,0,2.27H18.62Z"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 11.03,
    y: 10.8,
    width: 2.83,
    height: 0.57
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 10.35,
    y: 9.22,
    width: 4.42,
    height: 0.68
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 12.16,
    y: 7.74,
    width: 2.49,
    height: 0.68
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 10.46,
    y: 7.74,
    width: 0.79,
    height: 0.68
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 11.82,
    y: 3.1,
    width: 2.83,
    height: 0.68
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 10.23,
    y: 3.1,
    width: 0.79,
    height: 0.68
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 8.71,
    y: 5.49,
    width: 1.47,
    height: 0.68,
    transform: "translate(15.27 -3.61) rotate(90)"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 10.29,
    y: 5.49,
    width: 1.47,
    height: 0.68,
    transform: "translate(16.86 -5.2) rotate(90)"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 11.76,
    y: 5.49,
    width: 1.47,
    height: 0.68,
    transform: "translate(18.33 -6.67) rotate(90)"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 13.35,
    y: 5.49,
    width: 1.47,
    height: 0.68,
    transform: "translate(19.91 -8.26) rotate(90)"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 14.82,
    y: 5.49,
    width: 1.47,
    height: 0.68,
    transform: "translate(21.39 -9.73) rotate(90)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25,18.52a1,1,0,0,0-1.47,0,.11.11,0,0,1-.13,0,.88.88,0,0,0-.94-.22.1.1,0,0,1-.13-.1v-2a1.09,1.09,0,0,0-1.14-.91s-1,0-1,.91v4.59a.15.15,0,0,1-.23.13l-.67-.41s-1.13-.57-1.59.22A.85.85,0,0,0,9.05,22l-.05,0,2.59,2h6.57V19.07s-.27-1.05-1.81-.53A.12.12,0,0,1,16.25,18.52Zm1.29,4.68H11.76L9.61,21.62c-.45-.91.45-.68.45-.68l1.66,1a.18.18,0,0,0,.27-.15V16.29c.45-.9,1,0,1,0v3.12a.18.18,0,0,0,.17.17h.06a.16.16,0,0,0,.15-.09c.55-1.1,1-.53,1.19-.11a.17.17,0,0,0,.3,0c.58-.86,1-.36,1.27,0a.18.18,0,0,0,.3,0c.61-.95,1.09-.08,1.09-.08Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.a86d30fa369206f4c59bc5b1a68ea24b.svg";
export { ForwardRef as ReactComponent };